import { Divider, List, Typography } from 'antd';
import React from 'react';

type Shortcut = {
  key: string;
  description: string;
};

const shortcuts: Shortcut[] = [
  {
    key: 'Del',
    description: 'Delete finding'
  },
  {
    key: 'Arrow Up',
    description: 'Previous image in list/Previous finding in list'
  },
  {
    key: 'Arrow Down',
    description: 'Next image in list/Next finding in list'
  },
  {
    key: '0 (zero)',
    description: 'Toggle findings visibility'
  },
  {
    key: 'Shift +',
    description: 'Zoom in image'
  },
  {
    key: 'Shift -',
    description: 'Zoom out image'
  },
  {
    key: 'Ctrl F11',
    description: 'Toggle fullscreen mode'
  },
  {
    key: 'Ctrl A',
    description: 'Select all finding on the image'
  },
  {
    key: 'Ctrl I',
    description: 'Toggle image settings popup'
  }
];

const Shortcuts = () => {
  return (
    <>
      <Divider orientation='left'>Shortcuts</Divider>
      <List
        header={<div>[Keyboard keys] | Description</div>}
        bordered
        dataSource={shortcuts}
        renderItem={item => (
          <List.Item key={item.key} style={{ justifyContent: 'flex-start' }}>
            <Typography.Text mark>[{item.key}]</Typography.Text> | {item.description}
          </List.Item>
        )}
      />
    </>
  );
};

export default Shortcuts;
